import { Link } from 'react-router-dom';
import '../styles/inner.css';
import '../styles/home.css';

const sideLinks = [
  { to: '/about', label: 'About-Us', active: true },
  { to: '#', label: 'Excellence' },
  { to: '/about/software-development', label: 'Software Development Overview' },
  { to: '/about', label: 'Software testing' },
  { to: '#', label: 'Team Work' },
  { to: '#', label: 'Competitive' },
  { to: '#', label: 'Employer of Choice' },
];

const facts = [
  { icon: 'fa-calendar',   value: '7+',   label: 'Years of experience' },
  { icon: 'fa-map-marker', value: '10',   label: 'Branches In All India' },
  { icon: 'fa-desktop',    value: '7+',   label: 'Years of Process Experience' },
  { icon: 'fa-users',      value: '500+', label: 'Resource strength' },
];

export default function About() {
  return (
    <>
      {/* BANNER */}
      <div className="inner-banner about" style={{ backgroundImage: "url('/images/overview-banner.png')" }}>
        <div className="container">
          <h1>About-Us</h1>
          <div className="sep" />
          <h4>Providing cutting edge IT solutions in the best way at the right time</h4>
        </div>
      </div>

      {/* CONTENT */}
      <div className="inner-bottom-sec">
        <div className="container">
          {/* SIDEBAR */}
          <div className="side-menu">
            <ul>
              {sideLinks.map((l, i) => (
                <li key={i} className={l.active ? 'active' : ''}>
                  <Link to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* MAIN */}
          <div className="inner-main-part">
            <div className="inner-tp-dis">
              <h3>Overview</h3>
              <p>Matrix Processing House has already created a niche for itself in the Retail Sector.</p>
              <p>Matrix Processing House has pan India presence through its network of 44 branches at all key locations in the country.</p>
              <p>Matrix Processing House leverages its strong IT infrastructure to provide totally automated and customised business solutions which blends very effectively with clients's existing work processes. We have the vertical industry knowledge and process expertise to deliver strategic value to clients, in addition to significant time and cost savings.</p>
              <p>We believe in collaborative, long-term client relationships that evolve and grow stronger over time. Our clients have grown with us since inception and are scaling up their operations every year.</p>
            </div>

            {/* OUR MISSION */}
            <div className="overviw-bx">
              <div className="content-lft">
                <h2>Our <span>Mission</span></h2>
                <p>To be the client's first choice for quality services at the competitive cost through working faster, simpler and together.</p>
                <p>To inspire and empower our employees to be their best – both Personally and professionally.</p>
                <p>To attract, retain and nurture good talent and ensuring a career path for our employees.</p>
              </div>
              <div className="content-rgt">
        <img src="/images/overview-img1.png" alt="Mission" style={{width:'220px', height:'220px', objectFit:'cover', borderRadius:'50%'}} />
              </div>
            </div>

            {/* OUR CLIENTS */}
            <div className="overviw-bx reverse">
              <div className="content-lft">
                <h2>Our <span>Clients</span></h2>
                <p>Document Management, Validation, Out Bound Call Center, Address Verification, Churn management B2B &amp; B2C, First &amp; Second Bill Explanation, Get Appointment, Health Check, E-Bill Promotion, Debt Management.</p>
              </div>
              <div className="content-rgt">
    <img src="/images/overview-img2.png" alt="Clients" style={{width:'220px', height:'220px', objectFit:'cover', borderRadius:'50%'}} />
              </div>
            </div>

            {/* OUR VISION */}
            <div className="overviw-bx">
              <div className="content-lft">
                <h2>Our <span>Vision</span></h2>
                <p>To be the most preferred company in the country to provide Customers' information processing solutions to clients to enable clients to understand customers/subscribers and thus to Optimize customers' usage of clients' services.</p>
                <p>Pro actively manage financial risk Build successful and lasting Customers' relationship.</p>
              </div>
              <div className="content-rgt">
               <img src="/images/overview-img3.png" alt="Vision" style={{width:'220px', height:'220px', objectFit:'cover'}} />
              </div>
            </div>

            {/* SOFTWARE DEVELOPMENT */}
            <div className="overviw-bx reverse">
              <div className="content-lft">
                <h2>Software <span>Development</span></h2>
                <p>We develop Mobile-based, windows-Based, web-Based, custom applications for businesses needing to streamline their daily business operations. Our developers empower our clients by simplifying the application development process and product.</p>
              </div>
              <div className="content-rgt">
               <img src="/images/overview-img4.png" alt="Software Development" style={{width:'220px', height:'220px', objectFit:'cover'}} />
              </div>
            </div>

            {/* SOFTWARE TESTING */}
            <div className="overviw-bx">
              <div className="content-lft">
                <h2>Software <span>Testing</span></h2>
                <p>We develop Mobile-based, windows-Based, web-Based, custom applications for businesses and test all Application client Based for daily business operations. Our developers empower our clients by simplifying the application development process and product.</p>
              </div>
              <div className="content-rgt">
               <img src="/images/overview-img5.png" alt="Software Testing" style={{width:'220px', height:'220px', objectFit:'cover'}} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FACTS BAND */}
      <section className="inner-facts">
        <div className="container">
          <h2>Some Facts <span>About Matrix Processing House</span></h2>
          <div className="fact-abut">
            {facts.map((f, i) => (
              <div className="fact-bx" key={i}>
                <div className="fact-icon"><i className={`fa ${f.icon}`} /></div>
                <div className="bdr-btm-fact" />
                <h2>{f.value}</h2>
                <p>{f.label}</p>
              </div>
            ))}
          </div>
          <div className="more-facts">
            <Link to="/about"><span>View More</span></Link>
          </div>
        </div>
      </section>
    </>
  );
}
